<template>
    <component :is="component" />
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import base from '~/components/base.vue';
// eslint-disable-next-line import/no-unresolved
import desktop from '~/components/event/worldcup/index.vue';

export default {
    extends: base,
    components: {
        desktop
    },
    middleware({ redirect }) {
        if (!process.env.EVENT_WORLDCUP || process.env.EVENT_WORLDCUP !== '1') {
            return redirect('/404');
        }
    }
};
</script>
